import { MyNaviPayPayLogo } from '@/components/Campaign/mynavi/Logo'
import { Skeleton } from '@/components/UI/Skeleton'
import { IconChevronRight } from '@tabler/icons-react'
import { MYNAVI_PRIMARY } from '../Color'
import { MyNaviTypography } from '../MyNaviUI/MyNaviTypography'

export type MyNaviPointDisplayProps = {
  /** 表示するポイント数（整数値） */
  points: number
  /** 「履歴」リンクがクリックされたときのコールバック */
  onHistoryClick: () => void
  /** 「交換 PayPay」ボタンがクリックされたときのコールバック */
  onExchangeClick: () => void
  /** 認証確定前のローディング状態。true の場合はスケルトンを表示する */
  loading?: boolean
}

export const MyNaviPointDisplay = ({
  points,
  onHistoryClick,
  onExchangeClick,
  loading = false,
}: MyNaviPointDisplayProps) => {
  if (loading) {
    return (
      <div style={{ margin: '0 8px' }}>
        <Skeleton variant="rect" height={100} />
      </div>
    )
  }

  return (
    <div
      style={{
        backgroundColor: MYNAVI_PRIMARY,
        borderRadius: '8px',
        padding: '8px 12px 0',
        margin: '0 8px',
      }}
    >
      {/* 上段：獲得ポイント + 数値 + 交換ボタン */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {/* 左：ポイント表示 */}
        <div>
          <MyNaviTypography variant="points-label">獲得ポイント</MyNaviTypography>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
            <MyNaviTypography variant="points">{points.toLocaleString('ja-JP')}</MyNaviTypography>
            <MyNaviTypography variant="points-label" as="span">
              ポイント
            </MyNaviTypography>
          </div>
        </div>

        {/* 右：交換 PayPay ボタン */}
        <button
          type="button"
          onClick={onExchangeClick}
          style={{
            backgroundColor: '#fbfbfb',
            borderRadius: '45px',
            height: '53px',
            width: '119px',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <MyNaviTypography variant="back-label">交換</MyNaviTypography>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src={MyNaviPayPayLogo.pppointLogo2} alt="PayPay" style={{ height: '28px', width: 'auto' }} />
          </div>
        </button>
      </div>

      {/* 区切り線 */}
      <div style={{ height: '1px', backgroundColor: 'rgba(255,255,255,0.5)', margin: '6px 0' }} />

      {/* 下段：履歴リンク */}
      <button
        type="button"
        onClick={onHistoryClick}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '2px',
          padding: '0 0 8px',
        }}
      >
        <MyNaviTypography variant="caption-white">履歴</MyNaviTypography>
        <IconChevronRight size={16} color="white" />
      </button>
    </div>
  )
}
